export default class BlockMap {
    static init() {
        const blocks = document.querySelectorAll(".block-map-container");

        blocks.forEach(block => {
            this.initTooltip(block);
        });
    }

    static initTooltip(block) {
        const tooltip = block.querySelector(".map-tooltip");
        if (!tooltip) {
            return;
        }

        const pointer = block.querySelector(".map-pointer");
        if (pointer) {
            pointer.addEventListener("click", () => {
               tooltip.classList.add("active");
            });
        }

        tooltip.querySelector(".close").addEventListener("click", () => {
           tooltip.classList.remove("active");
        });
    }
}